export const tunnelAddresses = {
  "us-east-1": "tunnel.us-east-1.hightouch.io",
  "eu-west-1": "tunnel.eu-west-1.hightouch.io",
};

export const whitelistAddresses = {
  "us-east-1": ["54.196.30.169", "52.72.201.213", "18.213.226.96", "3.224.126.197", "3.217.26.199"],
  "eu-west-1": ["34.255.226.212", "52.16.84.199", "52.211.114.138"],
};
